import React from 'react';

const GROUP_ICONS = {
  pin: (
    <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  network: (
    <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" />
      <rect x="4" y="14" width="6" height="6" rx="1" /><rect x="14" y="14" width="6" height="6" rx="1" />
    </svg>
  ),
  settings: (
    <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
    </svg>
  ),
  star: (
    <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  clock: (
    <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
};

const CheckIcon = () => (
  <svg width="12" height="12" fill="none" stroke="#fff" strokeWidth="3" viewBox="0 0 24 24">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function EVSEChecklist({ groups, selectedFields, onToggle, onSelectAllInGroup, onClearAllInGroup }) {
  return (
    <div className="checklist-panel">
      {groups.map(group => {
        const groupFieldNames = group.fields.map(f => f.name);
        const selectedInGroup = groupFieldNames.filter(name => selectedFields.includes(name)).length;

        return (
          <div className="checklist-group" key={group.key}>
            <div className="checklist-group-header">
              <span className="checklist-group-title">{group.title}</span>
              <span className="checklist-group-count">
                {selectedInGroup}/{group.fields.length}
              </span>
            </div>

            <div className="checklist-quick-actions">
              <button type="button" onClick={() => onSelectAllInGroup(groupFieldNames)}>
                Select all
              </button>
              <button type="button" onClick={() => onClearAllInGroup(groupFieldNames)}>
                Clear
              </button>
            </div>

            {group.fields.map(field => {
              const checked = selectedFields.includes(field.name);
              return (
                <div
                  key={field.name}
                  className={`checklist-item ${checked ? 'checked' : ''}`}
                  onClick={() => onToggle(field.name)}
                >
                  <div className="checklist-checkbox">
                    <CheckIcon />
                  </div>
                  <span style={{ color: 'var(--slate)', display: 'flex' }}>
                    {GROUP_ICONS[group.icon]}
                  </span>
                  <span className="checklist-label">{field.label}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}